// import { useEffect } from "react";
// import VerifiedImg from "../../../assets-user/mark.png";
// import DirectConnectImg from "../../../assets-user/group.png";
// import SmartSearchImg from "../../../assets-user/idea.png";
// import TrustImg from "../../../assets-user/search.png";
// import AffordableImg from "../../../assets-user/money.png";
// import SupportImg from "../../../assets-user/security.png";
// import buildingImg from "../../../assets-user/buildingImg.png";

// const LeadBookFeatures = () => {
//   const features = [
//     {
//       icon: VerifiedImg,
//       title: "Verified Listings",
//       description: "100% authentic and trustworthy property options.",
//     },
//     {
//       icon: DirectConnectImg,
//       title: "Direct Connect",
//       description: "Contact Owner & Builder, Save brokerage, connect directly",
//     },
//     {
//       icon: SmartSearchImg,
//       title: "Smart Search & Filters",
//       description: "Find your ideal property quickly and easily.",
//     },
//     {
//       icon: TrustImg,
//       title: "Transparency & Trust",
//       description: "No hidden charges, no false details.",
//     },
//     {
//       icon: AffordableImg,
//       title: "Affordable & Accessible",
//       description: "Premium property solutions at fair prices.",
//     },
//     {
//       icon: SupportImg,
//       title: "End-to-End Support",
//       description: "Guidance through every step of your property journey.",
//     },
//   ];

//   useEffect(() => {
//     // Load AOS CSS
//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href = "https://unpkg.com/aos@2.3.1/dist/aos.css";
//     document.head.appendChild(link);

//     // Load AOS JS
//     const script = document.createElement("script");
//     script.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
//     script.async = true;

//     script.onload = () => {
//       if (window.AOS) {
//         window.AOS.init({
//           duration: 800,
//           easing: "ease-in-out",
//           once: false,
//           mirror: true,
//           offset: 100,
//         });
//       }
//     };

//     document.body.appendChild(script);

//     return () => {
//       if (document.head.contains(link)) {
//         document.head.removeChild(link);
//       }
//       if (document.body.contains(script)) {
//         document.body.removeChild(script);
//       }
//     };
//   }, []);

//   return (
//     <div className="w-full px-4 sm:px-6 lg:px-10 py-10 bg-gradient-to-br from-blue-50 to-white">
//       <div className="mx-auto">
//         {/* Header Section */}
//         <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start">
//           <div
//             className="lg:mb-0 lg:w-1/3"
//             data-aos="fade-right"
//             data-aos-duration="800"
//           >
//             <h2
//               className="font-[Poppins] font-medium text-[24px] sm:text-[28px] md:text-[32px] tracking-[0.01em] text-[#031722] mb-1 sm:mb-2 md:mb-3 lg:mb-4"
//               data-aos="fade-down"
//               data-aos-duration="600"
//               data-aos-delay="100"
//             >
//               Why LeadBook is the Right Choice for You?
//             </h2>
//             <p
//               className="font-[Poppins] font-normal text-[16px] sm:text-[17px] md:text-[18px]sss tracking-[0.01em] text-[#B1B1B1]"
//               data-aos="fade-up"
//               data-aos-duration="600"
//               data-aos-delay="200"
//             >
//               We provide smart, reliable, and customized solutions that solve
//               your problems and make life easier.
//             </p>
//           </div>

//           {/* Building Illustration */}
//           <div
//             className="hidden lg:block"
//             data-aos="fade-left"
//             data-aos-duration="1000"
//             data-aos-delay="300"
//           >
//             <img
//               src={buildingImg}
//               alt="Building"
//               className="w-full"
//               data-aos="zoom-in"
//               data-aos-duration="800"
//               data-aos-delay="400"
//             />
//           </div>
//         </div>

//         {/* Features Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6 mt-4 xl:mt-0">
//           {features.map((feature, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-2xl p-5 md:p-6 lg:p-7 border border-gray-200 hover:border-red-300 hover:shadow-lg transition-all duration-300 group"
//               data-aos="fade-up"
//               data-aos-delay={index * 100}
//               data-aos-duration="800"
//             >
//               <div className="flex items-start gap-4">
//                 <div
//                   className="flex-shrink-0 group-hover:scale-110 transition-transform duration-300"
//                   data-aos="zoom-in"
//                   data-aos-delay={index * 100 + 100}
//                   data-aos-duration="500"
//                 >
//                   <img
//                     src={feature.icon}
//                     alt={feature.title}
//                     className="w-10 h-10 md:w-12 md:h-12 object-contain"
//                   />
//                 </div>
//                 <div className="flex-1">
//                   <h3
//                     className="font-[Poppins] font-medium text-[18px] sm:text-[20px] md:text-[22px] tracking-[0.01em] text-[#2F2F2F] mb-2"
//                     data-aos="fade-left"
//                     data-aos-delay={index * 100 + 150}
//                     data-aos-duration="500"
//                   >
//                     {feature.title}
//                   </h3>
//                   <p
//                     className="font-[Poppins] font-normal text-[14px] sm:text-[15px] md:text-[16px] tracking-[0.01em] text-[#A3A3A3]"
//                     data-aos="fade-up"
//                     data-aos-delay={index * 100 + 200}
//                     data-aos-duration="500"
//                   >
//                     {feature.description}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeadBookFeatures;

// import { useEffect } from "react";
// import VerifiedImg from "../../../assets-user/mark.png";
// import DirectConnectImg from "../../../assets-user/group.png";
// import SmartSearchImg from "../../../assets-user/idea.png";
// import TrustImg from "../../../assets-user/search.png";
// import AffordableImg from "../../../assets-user/money.png";
// import SupportImg from "../../../assets-user/security.png";
// import buildingImg from "../../../assets-user/buildingImg.png";

// const LeadBookFeatures = () => {
//   const features = [
//     {
//       icon: VerifiedImg,
//       title: "Verified Listings",
//       description: "100% authentic and trustworthy property options.",
//     },
//     {
//       icon: DirectConnectImg,
//       title: "Direct Connect",
//       description: "Contact Owner & Builder, Save brokerage, connect directly",
//     },
//     {
//       icon: SmartSearchImg,
//       title: "Smart Search & Filters",
//       description: "Find your ideal property quickly and easily.",
//     },
//     {
//       icon: TrustImg,
//       title: "Transparency & Trust",
//       description: "No hidden charges, no false details.",
//     },
//     {
//       icon: AffordableImg,
//       title: "Affordable & Accessible",
//       description: "Premium property solutions at fair prices.",
//     },
//     {
//       icon: SupportImg,
//       title: "End-to-End Support",
//       description: "Guidance through every step of your property journey.",
//     },
//   ];

//   useEffect(() => {
//     const link = document.createElement("link");
//     link.rel = "stylesheet";
//     link.href = "https://unpkg.com/aos@2.3.1/dist/aos.css";
//     document.head.appendChild(link);

//     const script = document.createElement("script");
//     script.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
//     script.async = true;

//     script.onload = () => {
//       if (window.AOS) {
//         window.AOS.init({
//           duration: 800,
//           easing: "ease-in-out",
//           once: true,
//           mirror: false,
//           offset: 100,
//         });
//       }
//     };

//     document.body.appendChild(script);

//     return () => {
//       if (document.head.contains(link)) document.head.removeChild(link);
//       if (document.body.contains(script)) document.body.removeChild(script);
//     };
//   }, []);

//   return (
//     <div className="w-full bg-gradient-to-br from-blue-50 to-white py-6 md:py-8 lg:py-10">
//       <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-10">
//         {/* Header Section */}
//         <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start">
//           <div
//             className="lg:mb-0 lg:w-1/3"
//             data-aos="fade-right"
//             data-aos-duration="800"
//           >
//             <h2
//               className="font-[Poppins] font-medium text-[24px] sm:text-[28px] md:text-[32px] leading-[150%] tracking-[0.01em] text-[#031722] mb-4"
//               data-aos="fade-down"
//             >
//               Why LeadBook is the Right Choice for You?
//             </h2>
//             <p
//               className="font-[Poppins] font-normal text-[16px] sm:text-[17px] md:text-[18px] leading-[150%] tracking-[0.01em] text-[#B1B1B1]"
//               data-aos="fade-up"
//             >
//               We provide smart, reliable, and customized solutions that solve
//               your problems and make life easier.
//             </p>
//           </div>

//           {/* Building Illustration */}
//           <div
//             className="hidden lg:block"
//             data-aos="fade-left"
//             data-aos-duration="1000"
//             data-aos-delay="300"
//           >
//             <img
//               src={buildingImg}
//               alt="Building"
//               className="w-full"
//               data-aos="zoom-in"
//               data-aos-duration="800"
//               data-aos-delay="400"
//             />
//           </div>
//         </div>

//         {/* Features Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
//           {features.map((feature, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-2xl p-5 md:p-6 lg:p-7 border border-gray-200 hover:border-red-300 hover:shadow-lg transition-all duration-300 group"
//               data-aos="fade-up"
//               data-aos-delay={index * 100}
//             >
//               <div className="flex items-start gap-4">
//                 <div className="flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
//                   <img
//                     src={feature.icon}
//                     alt={feature.title}
//                     className="w-10 h-10 md:w-12 md:h-12 object-contain"
//                   />
//                 </div>
//                 <div>
//                   <h3 className="font-[Poppins] font-medium text-[18px] sm:text-[20px] md:text-[22px] tracking-[0.01em] text-[#2F2F2F] mb-2">
//                     {feature.title}
//                   </h3>
//                   <p className="font-[Poppins] font-normal text-[14px] sm:text-[15px] md:text-[16px] leading-[150%] tracking-[0.01em] text-[#A3A3A3]">
//                     {feature.description}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeadBookFeatures;
import { useEffect } from "react";
import VerifiedImg from "../../../assets-user/mark.png";
import DirectConnectImg from "../../../assets-user/group.png";
import SmartSearchImg from "../../../assets-user/idea.png";
import TrustImg from "../../../assets-user/search.png";
import AffordableImg from "../../../assets-user/money.png";
import SupportImg from "../../../assets-user/security.png";
import buildingImg from "../../../assets-user/buildingImg.png";

const LeadBookFeatures = () => {
  const features = [
    {
      icon: VerifiedImg,
      title: "Verified Listings",
      description: "100% authentic and trustworthy property options.",
    },
    {
      icon: DirectConnectImg,
      title: "Direct Connect",
      description: "Contact Owner & Builder, Save brokerage, connect directly",
    },
    {
      icon: SmartSearchImg,
      title: "Smart Search & Filters",
      description: "Find your ideal property quickly and easily.",
    },
    {
      icon: TrustImg,
      title: "Transparency & Trust",
      description: "No hidden charges, no false details.",
    },
    {
      icon: AffordableImg,
      title: "Affordable & Accessible",
      description: "Premium property solutions at fair prices.",
    },
    {
      icon: SupportImg,
      title: "End-to-End Support",
      description: "Guidance through every step of your property journey.",
    },
  ];

  return (
    <div className="w-full bg-gradient-to-br from-blue-50 to-white py-6 md:py-8 lg:py-10">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-10">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start">
          <div
            className="lg:mb-0 lg:w-1/3"
            data-aos="fade-right"
            data-aos-duration="800"
          >
            <h2
              className="font-[Poppins] font-medium text-[24px] sm:text-[28px] md:text-[32px] leading-[150%] tracking-[0.01em] text-[#031722] mb-4"
              data-aos="fade-down"
            >
              Why LeadBook is the Right Choice for You?
            </h2>
            <p
              className="font-[Poppins] font-normal text-[16px] sm:text-[17px] md:text-[18px] leading-[150%] tracking-[0.01em] text-[#B1B1B1]"
              data-aos="fade-up"
            >
              We provide smart, reliable, and customized solutions that solve
              your problems and make life easier.
            </p>
          </div>

          {/* Building Illustration */}
          <div
            className="hidden lg:block"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <img
              src={buildingImg}
              alt="Building"
              className="w-full"
              data-aos="zoom-in"
              data-aos-duration="800"
              data-aos-delay="400"
            />
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-5 md:p-6 lg:p-7 border border-gray-200 hover:border-red-300 hover:shadow-lg transition-all duration-300 group"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-10 h-10 md:w-12 md:h-12 object-contain"
                  />
                </div>
                <div>
                  <h3 className="font-[Poppins] font-medium text-[18px] sm:text-[20px] md:text-[22px] tracking-[0.01em] text-[#2F2F2F] mb-2">
                    {feature.title}
                  </h3>
                  <p className="font-[Poppins] font-normal text-[14px] sm:text-[15px] md:text-[16px] leading-[150%] tracking-[0.01em] text-[#A3A3A3]">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadBookFeatures;
